import moment from "moment/moment";

export const DateConst = {
  formatIsoDate: (date: Date | string) => {
    if (!(date instanceof Date)) {
      date = new Date(date);
    }
    const yyyy: number = date.getFullYear();
    let mm: number | string = date.getMonth() + 1; // Months start at 0!
    let dd: number | string = date.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    return `${yyyy}-${mm}-${dd}`;
  },

  getYear(date?: Date | string | null): string {
    if (!date) return '';
    const year = DateConst.formatIsoDate(date).split('-')?.[0];
    return year ? year : 'Unknown';
  },
};

export enum DatePickerType {
  YEAR,
  MONTH,
  DAY
}

export interface IDateData {
  dateComponents: IDatePicker | null;
  type?: DatePickerType | null;
}

export interface IDatePicker {
  year?: number;
  month?: number;
  day?: number;
}
